export const getDriverLog = (state, action) => {
  const updateValue = {
    request: action.data,
    error: null,
  };
  return { ...state, getDriverLog: { ...state.getDriverLog, ...updateValue } };
};

export const getDriverLogSuccess = (state, action) => {

  const updateValue = {
    request: null,
    response: action.res,
    error: null,
  };
  return { ...state, getDriverLog: updateValue };

};

export const getDriverLogFail = (state, action) => {
  const updateValue = {
    request: null,
    response: null,
    error: action.error,
  };
  return { ...state, getDriverLog: updateValue };
};


export const getDriverLogCorrdinate = (state, action) => {
    const updateValue = {
        request: action.data,
        error: null,
    };
    return { ...state, getDriverLogCorrdinate: { ...state.getDriverLogCorrdinate, ...updateValue } };
};

export const getDriverLogCorrdinateSuccess = (state, action) => {

    const updateValue = {
        request: null,
        response: Array.isArray(action.res)
            ? action.res
            : Array.isArray(action.res?.coordinates)
                ? action.res.coordinates
                : action.res?.packetId
                    ? [action.res]
                    : [],
        error: null,
    };
    return { ...state, getDriverLogCorrdinate: updateValue };

};

export const getDriverLogCorrdinateFail = (state, action) => {
    const updateValue = {
        request: null,
        response: null,
        error: action.error,
    };
    return { ...state, getDriverLogCorrdinate: updateValue };
};



export const updateChangeLocationStatus = (state, action) => {
    const updateValue = {
        request: action.data,
        error: null,
    };
    return { ...state, updateChangeLocationStatus: { ...state.updateChangeLocationStatus, ...updateValue } };
};

export const updateChangeLocationStatusSuccess = (state, action) => {

    const updateValue = {
        request: null,
        response: action.res,
        error: null,
    };
    return { ...state, updateChangeLocationStatus: updateValue };

};

export const updateChangeLocationStatusFail = (state, action) => {
    const updateValue = {
        request: null,
        response: null,
        error: action.error,
    };
    return { ...state, updateChangeLocationStatus: updateValue };
};

export const getPlanChangeStatusesExcel = (state) => {
    return {
        ...state,
        planChangeStatusesExcel: {
            request: true,
            response: null,
            error: null,
        },
    };
};

export const getPlanChangeStatusesExcelSuccess = (state, action) => {
    return {
        ...state,
        planChangeStatusesExcel: {
            request: null,
            response: action.res,
            error: null,
        },
    };
};

export const getPlanChangeStatusesExcelFail = (state, action) => {
    return {
        ...state,
        planChangeStatusesExcel: {
            request: null,
            response: null,
            error: action.error,
        },
    };
};

export const clearPlanChangeStatusesExcel = (state) => {
    return {
        ...state,
        planChangeStatusesExcel: {
            request: null,
            response: null,
            error: null,
        },
    };
};